import { NoSsr } from "@mui/base";
import { useAtomValue } from "jotai";
import type { FunctionComponent } from "react";

import { BaseLink } from "~/components/common/base-link";
import { useLoginDialogStateHelper } from "~/components/login-dialog/hooks";
import { useTracking } from "~/components/posties/subscription-widget/hooks";
import type { Variant } from "~/components/posties/subscription-widget/types";
import { config } from "~/data";
import { accountAtom } from "~/lib/account";

import { Benefit, Container, IconArrow, Link, LogIn, LogInLink, Redeem, Subscribe } from "./styles";

type Props = {
  className?: string;
  hideSubscribeButton?: boolean;
  subscribeUrl: string;
  variant: Variant;
};

export const Footer: FunctionComponent<Props> = ({
  className,
  hideSubscribeButton,
  subscribeUrl,
  variant,
}) => {
  const subscribeHost = config.rosetta.subscribeHost;
  const { isLoggedIn } = useAtomValue(accountAtom);
  const { openLoginDialog } = useLoginDialogStateHelper();
  const { trackCompareBenefitClick, trackRedeemClick, trackSubscribeClick } = useTracking(variant);

  return (
    <Container className={className}>
      <Benefit
        pathname={`${subscribeHost}/posties`}
        target="_blank"
        onClick={trackCompareBenefitClick}
      >
        Compare benefits
        <IconArrow />
      </Benefit>
      {!hideSubscribeButton && (
        <Subscribe backgroundColor="#fecc17">
          <BaseLink pathname={subscribeUrl} target="_blank" onClick={trackSubscribeClick}>
            Subscribe
          </BaseLink>
        </Subscribe>
      )}
      <NoSsr>
        {!isLoggedIn && (
          <LogIn>
            Already a subscriber?{" "}
            <LogInLink
              onClick={() =>
                openLoginDialog({
                  application: "posties",
                  destination: window.location.href,
                  ga4CustomParameter: {
                    trigger_point: "posties",
                  },
                })
              }
            >
              Log In
            </LogInLink>
          </LogIn>
        )}
      </NoSsr>
      <Redeem>
        Or you can{" "}
        <Link
          pathname={`${subscribeHost}/posties/redeem`}
          target="_blank"
          onClick={trackRedeemClick}
        >
          Redeem
        </Link>{" "}
        here
      </Redeem>
    </Container>
  );
};
